<template>
  <div class="page-mobile-content">
      <downBtnVue @toWant="changeShowType"></downBtnVue>
      <div class="content-module">
          <div class="module-item">
              <div class="item-title">关于ISC.AI 2026</div>
              <div class="item-introduceText">
                ISC.AI大会作为全球规格最高、规模最大、影响力最深远的“AI+安全”盛会之一，历经十三年积淀，已汇聚超700场技术交锋、5000+行业里程碑议题，吸引全球30多个国家的2000余位政要、行业领袖、专家学者深度参与。
              </div>
              <div class="item-introduceText">
                2026年，我们正式步入“智能体规模化应用元年”。智衍万物，安全共生——ISC.AI
                2026将聚焦AI从“大模型”向“智能体”演进过程中的技术突破、安全挑战与产业重塑，致力于成为全球智能体时代的技术风向标与安全守门人。
              </div>
          </div>
          <div class="module-item">
              <div class="item-title">你的声音，值得被世界听见</div>
              <div class="item-content">
                <img class="content-img" src="https://p2.ssl.qhimg.com/t110b9a9301bc765a292f60ff0e.png" alt="">
                <img class="content-img" style="margin-top: 40px;" src="https://p3.ssl.qhimg.com/t110b9a93018d2d1be28724947d.png" alt="">
              </div>
          </div>
          <div class="module-item" style="background: #ffffff; padding: 40px 20px;">
              <div class="item-title">三步完成申报，解锁全球舞台</div>
              <div class="item-content">
                <img class="content-img" src="https://s3.ssl.qhres2.com/static/3d95169ba66ed058.svg" alt="">
              </div>
          </div>
      </div>
      <div class="content-hot">
          <div class="hot-title">纳米AI智能体推荐热门议题</div>
          <!-- <div class="hot-tishi">
                点一下议题试试<img src="https://p1.ssl.qhimg.com/t110b9a93016ae6a9f36c0a7f75.png" alt="">
            </div> -->
          <div class="hot-content">
              <hotsVue v-if="showHots" :list="topicListFormat"></hotsVue>
          </div>
          <img class="hot-update" @click="getTopicList()" src="https://p4.ssl.qhimg.com/t110b9a93014ad74581bdbdf92b.png" alt="">
      </div>
      <div class="content-join" v-if="showType != 0" id="topicJoin">
          <div class="join-title">{{showType==1?'我要讲 议题报名':'我要听 议题报名'}}</div>
          <div class="join-box">
            <speakFormsVue v-if="showType == 1"></speakFormsVue>
            <listenFormsVue v-if="showType == 2"></listenFormsVue>
          </div>
      </div>
  </div>
</template>

<script setup>
import { ref,reactive,onMounted } from 'vue';
import downBtnVue from '../components/mobile/downBtn.vue'
import hotsVue from '../components/mobile/hots.vue'
import speakFormsVue from '../components/mobile/speakForms.vue'
import listenFormsVue from '../components/mobile/listenForms.vue'
import { topicList } from '@/mock/2026/topic.js';

let topicListFormat = ref([])
let showHots = ref(false)
let showType = ref(0) // 0 不显示 1 显示讲 2 显示听

onMounted (() => {
  getTopicList()
})

const getTopicList = () => {
    showHots.value = false
    //从topicList中无规则随机获取30个议题
    topicListFormat.value = getRandomTopics(topicList, 25)
    setTimeout(() => {
        showHots.value = true
    }, 200);
}

function getRandomTopics(list, count = 25) {
  const result = []
  const used = new Set()

  while (result.length < count && result.length < list.length) {
    const index = Math.floor(Math.random() * list.length)
    if (!used.has(index)) {
      used.add(index)
      result.push(list[index])
    }
  }
  return result
}

function scrollToElementWithOffset(element, offset = 0) {
  const elementPosition = element.getBoundingClientRect().top + window.pageYOffset;
  window.scrollTo({
    top: elementPosition - offset,
    behavior: 'smooth', // 平滑滚动
  });
}
const changeShowType = (item) =>{
    // if(showType.value == 0){
        showType.value = item
        setTimeout(() => {
            scrollToElementWithOffset(document.getElementById('topicJoin'), 32);
        },300);
    // }else{
    //     showType.value = item
    // }
}
  

</script>
<style lang="scss" scoped>

.page-mobile-content{
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 64px 0;
  background: rgba(246, 248, 250, 1);

  .content-module{
      width: 100%;
      display: flex;
      flex-direction: column;
      .module-item{
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          margin-bottom: 50px;
          padding: 0 20px;
          .item-title{
            color: rgb(44, 44, 44);
            font-family: Source Han Sans;
            font-size: 28px;
            font-weight: 700;
            line-height: 36px;
            letter-spacing: 0px;
            text-align: center;
            margin-bottom: 24px;
          }
          .item-introduceText {
            width: 100%;
            color: rgb(44, 44, 44);
            font-family: Source Han Sans;
            font-size: 16px;
            font-weight: 400;
            line-height: 28px;
            letter-spacing: 0px;
            text-align: justify;
            margin-bottom: 14px;
          }
          .item-content{
            width: 100%;
            margin-top: 16px;
            .content-img{
                width: 100%;
            }
          }
      }
  }
  .content-hot{
      width: 100%;
      padding: 0px 0 60px;
      display: flex;
      flex-direction: column;
      align-items: center;
    //   background: rgb(255, 255, 255);
      .hot-title{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 28px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: center;
        margin-bottom: 12px;
      }
      .hot-tishi{
          display: flex;
          align-items: center;
          color: rgb(44, 44, 44);
          font-family: Source Han Sans;
          font-size: 14px;
          font-weight: 400;
          line-height: 28px;
          letter-spacing: 0px;
          margin-bottom: 10px;
          img{
              width: 18px;
              transform: rotate(180deg);
              margin-left: 2px;
          }
      }
      .hot-content{
          width: 100%;
          height: 252px;
          display: flex;
          justify-content: center;
          align-items: center;
      }
      .hot-update{
          cursor: pointer;
          height: 20px;
      }
  }
  .content-join{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      .join-title{
        color: rgb(44, 44, 44);
        font-family: Source Han Sans;
        font-size: 28px;
        font-weight: 700;
        line-height: 28px;
        letter-spacing: 0px;
        text-align: center;
        margin-bottom: 24px;
      }
      .join-box{
          width: 100%;
          display: flex;
      }
  }
  .content-rules{
      width: 100%;
      display: flex;
      flex-direction: column;
      align-items: center;
      margin-top: 104px;
      .rules-title{
          color: rgb(44, 44, 44);
          font-family: Source Han Sans;
          font-size: 36px;
          font-weight: 700;
          line-height: 36px;
          letter-spacing: 0px;
          text-align: center;
          margin-bottom: 16px;
      }
      .rules-subtitle {
          color: rgb(177, 176, 176);
          font-family: Outfit;
          font-size: 16px;
          font-weight: 300;
          line-height: 18px;
          letter-spacing: 0px;
          text-align: center;
          text-transform: uppercase;
          margin-bottom: 59px;
      }
  }
}
</style>